import { useModelLabel } from "@judo/i18n";
import type { VisualElement } from "@judo/model-api";
import { Box, Divider, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { IconRenderer } from "./IconRenderer";
import { DIVIDER_HEIGHT } from "./renderer-constants";

export interface DividerRendererProps {
	element: VisualElement;
}

/**
 * Divider renderer using MUI Divider component.
 * Matches the template pattern: Grid container with fixed height, MUI Divider with optional icon/label.
 */
export function DividerRenderer({ element }: DividerRendererProps) {
	const { label } = useModelLabel(element);
	const hasContent = label || element.icon;

	return (
		<Grid container sx={{ height: DIVIDER_HEIGHT }} alignItems="center" data-testid={`divider::${element["xmi:id"]}`}>
			<Grid size={12}>
				<Divider>
					{hasContent && (
						<Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
							{element.icon && (
								<Box sx={{ mr: ".2rem" }}>
									<IconRenderer icon={element.icon} />
								</Box>
							)}
							{label && <Typography>{label}</Typography>}
						</Box>
					)}
				</Divider>
			</Grid>
		</Grid>
	);
}
